/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { RouteObject } from "react-router-dom";

import { CardsRouter } from "./CardsRouter";
import { CARDS_ROUTES } from "./constants";

export const cardsRoutes: RouteObject[] = [{ path: CARDS_ROUTES.ROOT, element: <CardsRouter /> }];
